import { useMutation, useQueryClient } from 'react-query';
import { useApiDownload, useApiFileUpload } from '../../../api';
import { useBuildVars } from '../../../config/build-config';

export type DiscountUploadRequest = {
  createdBy: string;
  file: File;
  modifiedBy: string;
  programId: number;
  programName: string;
  vendorId: number;
  vendorName: string;
};

export type DiscountUploadResponse = {
  message: string;
  statusCode: number;
};

export function useDiscountUpload(onProgress: (progress: number) => void) {
  const buildVars = useBuildVars();
  const queryClient = useQueryClient();
  const { upload, xhr } = useApiFileUpload<DiscountUploadResponse>(onProgress, {
    host: buildVars.VP_API_BASE,
  });

  const uploadApi = useMutation(
    (req: DiscountUploadRequest) => {
      const formData = new FormData();
      for (const key in req) {
        const value = (req as any)[key];
        formData.append(key, value);
      }
      return upload(
        '/system.webapi.gds/api/v1/GdsCoreApiUpload/UploadDiscount',
        formData
      );
    },
    {
      onSuccess: (data) => {
        queryClient
          .invalidateQueries(
            '/system.webapi.gds/api/v1/gdsCoreApiVendor/vendorProgram'
          )
          .catch(() => undefined);
      },
    }
  );
  return { uploadApi, xhr };
}

export interface DiscountDownloadRequest {
  uploadid: number;
}
export function useDiscountDownloadFile(params: DiscountDownloadRequest) {
  const buildVars = useBuildVars();
  const apiGetDownload = useApiDownload({ host: buildVars.VP_API_BASE });
  return useMutation(() =>
    apiGetDownload(
      '/system.webapi.gds/api/v1/GdsCoreApiUpload/DownloadDiscount',
      params
    )
  );
}
